// global/notifications/notifications
function hideNotifications(notification) {
    notification.removeClass('visible');
}

$(document).ready(function () {

    $('#show-notification-header').click(function () {
        $('.btn-notification').removeClass('active');
        var $notification = $('.notification--panel');
        if (!$notification.hasClass('visible')) {
            $notification.addClass('visible');
            $('body').addClass('notification-overlay');
            $.get({
              url: '/user/set/notifications'
            });
        } else {
            hideNotifications($notification);
            $('body').removeClass('notification-overlay');
        }
    });
    $(document).on('click', function(event) {
        var $target = $(event.target);
        if($target.parents('.notification-nav').length == 0 && !$target.closest('.notification--panel').length) {
            hideNotifications($('.notification--panel'));
            $('body').removeClass('notification-overlay');
        }
    });
});
